// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayPicker__horizontal {
  box-shadow: none;
  margin-left: -7px;
}

.DayPicker__verticalScrollable {
  height: 100%;
  overflow-x: hidden;
}

.CalendarMonth {
  margin-top: 10px;
}

.CalendarMonthGrid__vertical_scrollable {
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@htmniseko/htm-ui/DatePicker/css/DatePicker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".DayPicker__horizontal {\n  box-shadow: none;\n  margin-left: -7px;\n}\n\n.DayPicker__verticalScrollable {\n  height: 100%;\n  overflow-x: hidden;\n}\n\n.CalendarMonth {\n  margin-top: 10px;\n}\n\n.CalendarMonthGrid__vertical_scrollable {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
